export const PROMO_PATH = '/promo/';

export const PROMO_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/promo';

export const PROMO_ELEMENT_BLOCK = 'promoSection';

export const PROMO_LANDING_NAME = 'promo';

export const PROMO_BANNER = {
  bgColor: '#000000',
  elementBlock: PROMO_ELEMENT_BLOCK,
  content: {
    media: {
      alt: 'Акции для профессионалов',
      srcD: `${PROMO_CDN_PATH}/banner/banner-d.png/banner-d-1.png`,
      srcT: `${PROMO_CDN_PATH}/banner/banner-t.png/banner-t-1.png`,
      src: `${PROMO_CDN_PATH}/banner/banner-m.png/banner-m-1.png`,
    },
    title: 'Собрали выгодные акции',
    text: 'Только для юрлиц и\u00A0профессионалов',
  },
  link: {
    href: '/biznes/akcii/',
    title: 'Акции для бизнеса',
  },
  promotion: {
    name: 'promoSectionMiddle',
    creative: 'Собрали выгодные акции',
    position: '1',
  },
};
